import React, { useEffect, useState } from 'react';
import { Title, SubTitle, Card, List, Button } from '../../components/UI';

import {
  Container,
  AlignButton,
  AlignTitle,
} from '../../styles/pages/cashback/styles';

import { BalanceCashback, Order } from '../../models/cashback';
import { useCashback } from '../../hooks/cashback';
import LoadingListItem from '../../components/Shimmer/LoadingListItem';
import LoadingBalanceCashbackCards from '../../components/Shimmer/LoadingBalanceCashbackCards';
import withAuth from '../../components/HigherOrder/withAuth';
import Invest from '../../components/Modal/Invest';
import Link from 'next/link';
import { FlatButton, LockField, LockList } from '../../components/UI/Button/styles';
import { Popper } from '@mui/material';
import CaretDown from '../../assets/caret-down.svg';
import BigNumber from 'bignumber.js';
import { Content } from '../../styles/pages/home/styles';
import { useUser } from '../../hooks/user';
import { IgetAdsAccount } from '../../models/user';
import { t } from 'i18next';
import { useAuth } from '../../hooks/auth';
import Skeleton from '../../components/Skeleton';
import NoItemFound from '../../components/UI/NoItemFound';

const Cashback: React.FC = () => {
  const { localCountry } = useAuth();

  const [loadingBalanceCashback, setLoadingBalanceCashback] = useState(true);
  const [balanceCashback, setBalanceCashback] = useState<BalanceCashback>();
  const [investModalOpen, setInvestModalOpen] = useState(false);
  const [adsbalance, setAdsBalance] = useState<IgetAdsAccount>();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  const { getBalanceCashback } = useCashback();
  const { getAdsAccount } = useUser();

  useEffect(() => {
    async function getInitialData() {
      try {
        const balanceCashbackData = await getBalanceCashback();
        if (balanceCashbackData) {
          setBalanceCashback(balanceCashbackData);
        }
        setLoadingBalanceCashback(false);
      } catch (error) {
        setLoadingBalanceCashback(false);
      }
    }

    getInitialData();
  }, []);

  useEffect(() => {
    async function getInitialData() {
      try {
        const response = await getAdsAccount();
        setAdsBalance(response);
      } catch (error) {
        console.error(error);
      }
    }

    getInitialData();
  }, []);

  const handleOpenInvestModal = () => {
    setInvestModalOpen(true);
  };

  const handleUpdateCashback = async () => {
    try {
      setLoadingBalanceCashback(true);
      const balanceCashbackData = await getBalanceCashback();
      if (balanceCashbackData) {
        setBalanceCashback(balanceCashbackData);
      }
      setLoadingBalanceCashback(false);
    } catch (error) {
      console.log(error);
      setLoadingBalanceCashback(false);
    }
  };

  const handleCloseInvestModal = (done?: boolean) => {
    setInvestModalOpen(false);

    if (done) {
      handleUpdateCashback();
    }
  };

  const totalLockedFormatted = balanceCashback?.total_locked.filter(
    item => new BigNumber(item.balance).isZero() === false
  );

  return (
    <>
      {investModalOpen && (
        <Invest
          cashback={{
            available: balanceCashback?.total_available_to_invest,
            available_formatted:
              balanceCashback?.total_available_to_invest_formatted,
            in_btc: balanceCashback?.total_available_to_invest_in_btc_formatted,
          }}
          open={investModalOpen}
          onClose={handleCloseInvestModal}
        />
      )}
      <Container>
        <AlignTitle>
          <Title>{t('pages.cashback.my-wallet')}</Title>
          
          { localCountry === 'BR' ?
          <div className="alignHelp">
            <a
              href="https://cointimes.zendesk.com/hc/pt-br/articles/360060732992-Fiz-a-compra-e-n%C3%A3o-re[…]%A3o-do-meu-cashback-como-eu-posso-pedir-uma-an%C3%A1lise-"
              target="_blank"
            >
              Meu cashback não apareceu?
              <div className="question">?</div>
            </a>
          </div> : <></> }
        </AlignTitle>
        
        { localCountry ?
          localCountry == 'BR' ? (
          loadingBalanceCashback ? (
            <LoadingBalanceCashbackCards />
          ) : (
            <Card.Wraper>
              <div className="alignCards">
                <Card.Box flex={2} className="cashbackCard">
                  <Card.Text>Saldo disponível em BRL</Card.Text>
                  <Card.Row className="cashbackInfo">
                    <Card.Title>
                      {balanceCashback?.total_available_to_invest_formatted}
                    </Card.Title>
                    <Card.FeaturedText>
                      ~{' '}
                      {
                        balanceCashback?.total_available_to_invest_in_btc_formatted
                      }
                    </Card.FeaturedText>
                  </Card.Row>
                  <div className="button box" style={{display: 'flex', width: '100%', gap: 10}}>
                    <FlatButton
                      className="invest"
                      onClick={handleOpenInvestModal}
                      style={{flex: 1}}
                    >
                      Converter
                    </FlatButton>
                    <Link 
                      href="/cashout" 
                      passHref
                    >
                      <FlatButton
                        light
                        style={{flex: 1}}
                      >
                        Sacar
                      </FlatButton>
                    </Link>
                  </div>
                </Card.Box>
                <Card.Box flex={2} className="cashbackCard">
                  <Card.Text>Saldo disponível em BTC</Card.Text>
                  <Card.Title>
                    {balanceCashback?.total_invested_in_btc_formatted}
                  </Card.Title>

                  {totalLockedFormatted?.length || (adsbalance && adsbalance.balance_pending_formatted != '0') ? (
                    <LockField>
                      <p> Em processamento... </p>
                      <div className="currencyLocked">
                        <span>
                          {totalLockedFormatted?.length ? totalLockedFormatted[0]?.balance_formatted : `${adsbalance.balance_pending_formatted} sat`}
                          {(totalLockedFormatted?.length && (adsbalance && adsbalance.balance_pending_formatted != '0')) ? (<CaretDown onClick={handleClick} />) : null}
                        </span>
                      </div>

                      <Popper id={id} open={open} anchorEl={anchorEl} transition>
                        {({ TransitionProps }) => (
                          <LockList>
                            {totalLockedFormatted
                              .map((item, index) => {
                                return (
                                  <li key={index}>{item.balance_formatted}</li>
                                );
                              })
                              .slice(1)}
                            <li key={adsbalance.balance}> Extensão: {adsbalance.balance_formatted} sat </li>
                          </LockList>
                        )}
                      </Popper>
                    </LockField>
                  ) : (
                    <Link href="/cashout" passHref>
                      <Card.Action>Sacar meus bitcoins</Card.Action>
                    </Link>
                  )}
                </Card.Box>
              </div>
              <Card.Box className="cashbackCard">
                <Card.Text>Saldo Pendente</Card.Text>
                <Card.Title>
                  {balanceCashback?.total_balance_pending_cashback_formatted}
                </Card.Title>
                <Card.Text>
                  <a
                    href="https://cointimes.zendesk.com/hc/pt-br/articles/360061127471-Qual-%C3%A9-o-tempo-m%C3%A9dio-para-eu-receber-o-meu-cashback-"
                    target="_blank"
                  >
                    Porque está pendente?
                  </a>
                </Card.Text>
              </Card.Box>
            </Card.Wraper>
          )) :

          <Card.Wraper>
            <div className="alignCards">
              <Card.Box style={{boxShadow: 'none', borderWidth: 2, margin: 0, gap: 10, padding: 25, height: 'auto'}}>
                <Card.Text>{t('pages.cashback.available-balance-in-btc')}</Card.Text>
                <Card.Title>
                  { loadingBalanceCashback ?
                    <>
                      <Skeleton style={{height: 40, width: '100%', maxWidth: 300}} />
                    </>
                  :
                    balanceCashback?.total_invested_in_btc_formatted
                  }
                </Card.Title>

                {totalLockedFormatted?.length || (adsbalance && adsbalance.balance_pending_formatted != '0') ? (
                  <LockField>
                    <p>{t('pages.cashback.processing')}</p>
                    <div className="currencyLocked">
                      <span>
                        {totalLockedFormatted?.length ? totalLockedFormatted[0]?.balance_formatted : `${adsbalance.balance_pending_formatted} sat`}
                        {(totalLockedFormatted?.length && (adsbalance && adsbalance.balance_pending_formatted != '0')) ? (<CaretDown onClick={handleClick} />) : null}
                      </span>
                    </div>

                    <Popper id={id} open={open} anchorEl={anchorEl} transition>
                      {({ TransitionProps }) => (
                        <LockList>
                          {totalLockedFormatted
                            .map((item, index) => {
                              return (
                                <li key={index}>{item.balance_formatted}</li>
                              );
                            })
                            .slice(1)}
                          <li key={adsbalance.balance}>{t('pages.cashback.extension')}: {adsbalance.balance_formatted} sat </li>
                        </LockList>
                      )}
                    </Popper>
                  </LockField>
                ) : <></>}
                <Link href="/cashout" passHref>
                  <FlatButton style={{maxWidth: 120}}>{t('pages.cashback.withdraw-button')}</FlatButton>
                </Link>
              </Card.Box>
            </div>
          </Card.Wraper>
        : <></> }


        {/* <div className="alignBanner">
          <Content>
            <Link href="/rewards/home">
              <img
                src="https://cointimes.com.br/wp-content/uploads/2023/03/5.jpg"
                alt="banner"
              />
            </Link>
          </Content>
        </div> */}
        { localCountry === 'BR' ?
          <CashbackOrderHistory/>
        : <></> }
      </Container>
    </>
  );
};

const CashbackOrderHistory: React.FC = () => {
  const { getOrders } = useCashback();
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(true);
  const [enableShowMore, setEnableShowMore] = useState(false);
  const [page, setPage] = useState(0);


  useEffect(() => {
    async function getInitialData() {
      try {
        const ordersData = await getOrders(page);
        if (ordersData) {
          if (ordersData.length >= 20) {
            setEnableShowMore(true);
          }
          setOrders(ordersData);
          setPage(page + 1);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }

    getInitialData();
  }, []);

  const handleShowMore = async () => {
    try {
      setLoading(true);
      const ordersData = await getOrders(page + 1);
      if (ordersData.length < 20) {
        setEnableShowMore(false);
      }
      setOrders([...orders, ...ordersData]);
      setPage(page + 1);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleFormatStatus = (status: string) => {
    switch (status) {
      case 'PENDING':
        return 'Pendente';
      case 'CONFIRMED':
        return 'Confirmado';
      case 'AVAILABLE':
        return 'Disponível';
      case 'CANCELED':
        return 'Cancelado';
      default:
        return 'Indefinido';
    }
  };

  return (
    <>
      <SubTitle bold>Seu histórico de criptoback</SubTitle>
      <NoItemFound text='Nenhuma compra realizada' show={!loading && orders.length === 0}/>
      <List.Container className="cashbackItems">
        {orders.map((order: Order, index) => {
          return (
            <List.Row key={index} className="alignRow">
              <div className="alignItems">
                <List.ItemText>{order.advertiser.name}</List.ItemText>
                <List.ItemText>{order.created_at_formatted}</List.ItemText>
              </div>
              <List.ItemProgressBar
                value={order.progress}
                status={order.status}
              />
              <div className="alignItems">
                <List.ItemText>
                  {handleFormatStatus(order.status)}
                </List.ItemText>
                <List.ItemText>
                  {order.cashback_amount_formatted}
                </List.ItemText>
              </div>
            </List.Row>
          );
        })}
        {loading &&
          [...Array(20)].map((_, index) => <LoadingListItem key={index} />)}
        {enableShowMore && (
          <AlignButton>
            <Button className="showMore" onClick={handleShowMore}>
              Ver Mais
            </Button>
          </AlignButton>
        )}
      </List.Container>
    </>
  )
}

export default withAuth(Cashback);
